/**Import react section */
import React, { useState, useEffect } from 'react'
import propTypes from 'prop-types'
import { Grid, Button, Typography, Divider } from '@material-ui/core'

/**Import components section */
import TextBox from '../../../common/TextBox'
import WarrantyChecksPanel from './WarrantyChecksPanelComponent'
import LateralPanel from '../../../common/lateralPanel/LateralPanel'
import SeriesTable from './SeriesTableComponent'

const AddSerieStep = (props) => {
	const { service } = props
	const { onDeleteSerieFromService } = props
	const [serieValue, setSerieValue] = useState('')
	const [isLoadingService, setIsLoadingService] = useState(false)
	const [lastAddedSerie, setLastAddedSerie] = useState(null)
	const [lateralPanelEquipment, setLateralPanelEquipment] = useState({
		opened: false,
		equipment: null
	})

	const handleAddSerie = async () => {
		if (!serieValue.trim()) {
			alert('Please enter a valid serial number')
			return
		}

		const trimmedSerie = serieValue.trim()
		const serieExists = service.Equipments.some((s) => s.Serie === trimmedSerie)
		if (serieExists) {
			alert('This serial number has already been added')
			return
		}

		try {
			setIsLoadingService(true)
			if (props.onAddSeries) {
				await props.onAddSeries(trimmedSerie)
				setSerieValue('')
				setLastAddedSerie(trimmedSerie)
			}
		} catch (error) {
			console.error('Error adding serie:', error)
			alert('Error adding serial: ' + (error.message || 'Unknown error'))
		} finally {
			setIsLoadingService(false)
		}
	}

	useEffect(() => {
		if (lastAddedSerie && service?.Equipments?.length) {
			const newSerie = service.Equipments.find((s) => s.Serie === lastAddedSerie)
			if (newSerie) {
				setLateralPanelEquipment({
					opened: true,
					equipment: newSerie
				})
				setLastAddedSerie(null) // ✅ limpiamos para no volver a abrirlo
			}
		}
	}, [service, lastAddedSerie])

	const handleWarrantyIconClick = (equipment) => {
		setLateralPanelEquipment({
			opened: true,
			equipment: equipment
		})
	}

	const onCloseButtonClick = () => {
		setLateralPanelEquipment({ opened: false, equipment: null })
	}

	const onPropertyChange = (event) => {
		const { value } = event.target
		setSerieValue(value)
	}

	const handleKeyPress = (event) => {
		if (event.key === 'Enter') {
			event.preventDefault()
			handleAddSerie()
		}
	}

	return (
		<>
			<div>
				<Grid container spacing={1} alignItems='center'>
					<Grid item xs={12} sm={10}>
						<Typography variant='subtitle2'>
							Enter the serial number of your product, it must contain 12 digits, to validate serial in SAP.
						</Typography>

						<TextBox
							key='serie'
							active={true}
							disabled={isLoadingService}
							fullWidth
							multiline={false}
							name='serie'
							variant='outlined'
							margin='dense'
							label='SERIE'
							onChange={onPropertyChange}
							onKeyDown={handleKeyPress}
							value={serieValue}
						/>
					</Grid>
					<Grid item xs={12} sm={2}>
						<Button
							variant='contained'
							color='primary'
							fullWidth
							onClick={handleAddSerie}
							style={{ height: '40px', marginTop: '18px' }}
							disabled={isLoadingService}
						>
							{isLoadingService ? 'Cargando...' : 'Agregar'}
						</Button>
					</Grid>
				</Grid>
				<Divider style={{ margin: '12px 0' }} />
				<div
					style={{
						flex: 1,
						overflow: 'hidden',
						display: 'flex',
						flexDirection: 'column',
						minHeight: 0
					}}
				>
					<SeriesTable
						//functions
						onDeleteSerieFromService={onDeleteSerieFromService}
						onWarrantyIconClick={handleWarrantyIconClick}
						onNextStep={props.onNavigateToChecklist}
						//object service
						service={service}
					/>
				</div>
			</div>

			{/* Lateral Panel */}
			{lateralPanelEquipment.opened && (
				<LateralPanel onClose={onCloseButtonClick} width={700}>
					<WarrantyChecksPanel
						onCloseButtonClick={onCloseButtonClick}
						equipment={lateralPanelEquipment.equipment}
						serviceType={lateralPanelEquipment.equipment ? lateralPanelEquipment.equipment.ServiceType : 0}
					/>
				</LateralPanel>
			)}
		</>
	)
}

AddSerieStep.propTypes = {
	onNavigateToList: propTypes.func,
	onNavigateToChecklist: propTypes.func.isRequired,
	onClearState: propTypes.func,
	onAddSeries: propTypes.func,
	service: propTypes.object,
	initialLoadComplete: propTypes.bool.isRequired
}

export default AddSerieStep
